import captionService from "CaptionService";
import type { CaptionRecord } from "./types";

export const trackingTimeline: CaptionRecord = {
  noHistory: () =>
    captionService.getString("f1acd6f0-7f57-43c7-9113-5570cd1ee63f", "A status update is not yet available"),
};
